import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { useSettings, Utils } from 'app/main/components';

interface CoursesAttendersRemoveDialogProps {
	model: any;
	updateRefresh: VoidFunction;
}

export const showCoursesAttendersRemoveDialog = (props: CoursesAttendersRemoveDialogProps) =>
	openDialog({
		children: <CoursesAttendersRemoveDialog {...props} />,
		maxWidth: 'xs',
		fullWidth: true
	});

export function CoursesAttendersRemoveDialog({ model, updateRefresh }: CoursesAttendersRemoveDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	function RemoveAttender() {
		Utils.executeStored({
			action: `st_courses_users_delete`,
			dispatch,
			data: { crus_uid: model.crus_uid },
			successHandler: () => {
				Utils.alertSuccessMsg(t);
				dispatch(closeDialog());
				updateRefresh?.();
			}
		});
	}

	return (
		<>
			<DialogTitle>{t('DIALOG_REMOVE_ATTENDER_TITLE')}</DialogTitle>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button onClick={RemoveAttender}>{t('DIALOG_ACTION_CONFIRM')}</Button>
			</DialogActions>
		</>
	);
}
